module.exports = __webpack_public_path__ + "img/04-ABITO-DIAMANTE-SML-STAMPE-LINO2.be17ff95.jpg";